import { get } from 'lodash'
import pluralize from 'pluralize'

// Returns an entity from the Redux store, given a resource type and id
// This assumes that entities of type 'Timeline' live at state.data.timelines.123
export function getEntity(state, props) {
  const { entityId, entityType } = props
  if (!entityId || !entityType) return null

  const stateBranch = pluralize(entityType).toLowerCase()
  if (false) {
    console.group('Getting an entity')
    console.log('stateBranch', stateBranch)
    console.log('entityId', entityId)
    console.log('entityType', entityType)
    console.log('state', state.data[stateBranch])
    console.groupEnd()
  }
  // Entity could be directly in the state branch, or under entities key if using
  // redux-toolkit entity adapter
  let entity = null
  const node = get(state, ['data', stateBranch])
  entity = get(node, [entityId]) || get(node, ['entities', entityId])
  return entity
}
